import { useTheme } from "@hooks";
import { spacing } from "@layout";
import { CSSProperties } from "react";
import styled from "styled-components";

export const useStyles = () => {
  const { theme } = useTheme();

  const styles: Record<string, CSSProperties> = {
    container: {
      maxWidth: 800,
      // Two-column review layout needs a wider form column in the entry shell.
      ["--entry-form-width" as string]: "720px",
    } as CSSProperties,
    city: {
      display: "flex",
      flexDirection: "row",
    },
    ssn: {
      flex: 1,
      padding: 0,
      marginBottom: spacing.m,
      justifyContent: "center",
      alignItems: "center",
      paddingLeft: spacing.xs,
      paddingRight: spacing.xs,
    },
    bottomSpacing: {
      marginBottom: spacing.m,
    },
    state: {
      height: 30,
    },
    residence: {
      fontSize: 12,
      marginLeft: spacing.xs,
      marginRight: spacing.xs,
      color: theme.text.error,
    },
  };

  return styles;
};

export const ItemContainer = styled.div`
  margin-bottom: ${spacing.m}px;
  flex: 1;
`;

export const Row = styled.div`
  display: flex;
  flex-direction: row;

  @media (max-width: 500px) {
    flex-direction: column;
  }
`;

export const Divider = styled.div`
  width: ${spacing.m}px;

  @media (max-width: 500px) {
    width: 0px;
  }
`;

export const Separator = styled.div`
  width: ${spacing.m}px;
`;

export const Footer = styled.div`
  display: flex;
  flex-direction: row;

  @media (max-width: 500px) {
    flex-direction: column-reverse;
  }
`;
